import React, { useRef, useState } from 'react';
import './VideoSection.css';

const VideoSection = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (playing) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setPlaying(!playing);
    }
  };

  return (
    <section className="video-section">
      <div className="container">
        <div className="video-wrapper" onClick={togglePlay}>
          <video
            ref={videoRef}
            src="/assets/uploads/EmbraceVideo.mp4"

            className="clinic-video"
            loop
            muted
            playsInline
          />
          {!playing && (
            <div className="play-overlay">
              <div className="play-btn">
                <svg viewBox="0 0 24 24" fill="white">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
